import { render, staticRenderFns } from "./RevenueApportionmentSetup.vue?vue&type=template&id=40f4760e&scoped=true"
import script from "./RevenueApportionmentSetup.vue?vue&type=script&lang=js"
export * from "./RevenueApportionmentSetup.vue?vue&type=script&lang=js"
import style0 from "./RevenueApportionmentSetup.vue?vue&type=style&index=0&id=40f4760e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f4760e",
  null
  
)

export default component.exports